import { MutationCache, QueryClient } from '@tanstack/react-query';
import { toast } from '../components/common/toasts';
import i18n from '../i18n';
import { isApiError } from './errors';

/** The message of a failed write: the server's localized problem, else a generic one. */
export function writeErrorMessage(error: unknown): string {
  if (isApiError(error)) return error.isVersionConflict ? i18n.t('errors.versionConflict') : error.message;
  // fetch() rejects with a TypeError when the server cannot be reached
  if (error instanceof TypeError) return i18n.t('errors.network');
  return i18n.t('errors.unexpected');
}

export function createQueryClient(options: { retry?: boolean } = {}) {
  return new QueryClient({
    // every write (create, update, delete, transition, publish, …) is a mutation: its failure is shown in a toast
    // (D35); the page still shows the details where they belong (error summary, banner next to the action)
    mutationCache: new MutationCache({ onError: (error) => void toast.error(writeErrorMessage(error)) }),
    defaultOptions: {
      queries: {
        retry: options.retry === false ? false : (count, error) => !(isApiError(error) && error.status >= 400 && error.status < 500) && count < 2,
        refetchOnWindowFocus: false,
      },
      mutations: { retry: false },
    },
  });
}
